import Settings from '@/orm/models/Company/Settings';
import { computed } from '@vue/composition-api';
import Company from '@/orm/models/Company/Company';
import Template from '@/orm/models/Company/Template';

export default function useCompany() {
  async function updateSettings(id, settings) {
    await Settings.api()
      .update(id, settings);
  }

  async function fetch() {
    await Company.deleteAll();
    await Company.api().fetch();
  }

  const company = computed(() => {
    return Company.query().withAllRecursive().first();
  });

  const addresses = computed(() => {
    return company.value?.addresses;
  });

  const templates = computed(() => {
    return Template.query().get();
  });

  async function getIntegrationTokenStatus(code) {
    const { response } = await Company.api().fetchIntegrationTokenStatus(code);
    const { data } = response;
    return data;
  }

  async function getTemplates() {
    await Template.api().fetch();
  }

  async function updateTemplateSettings(companyId, payload) {
    await Company.api().updateTemplateSettings(companyId, payload);
  }

  async function applyTemplate(companyId, payload) {
    await Company.api().applyTemplate(companyId, payload);
  }

  async function setRedacting(templateId) {
    await Company.api().setRedacting(templateId);
  }

  async function disableAllTemplates() {
    await Company.api().disableAllTemplates();
  }

  async function addCandidatesAdditionalFields(payload) {
    await Company.api().addCandidatesAdditionalFields(payload);
  }

  async function getCandidateAiProcessorSettings() {
    const { response } = await Company.api().getCandidateAiProcessorSettings();
    return response.data;
  }

  async function updateCandidateAiProcessorSettings(payload) {
    await Company.api().updateCandidateAiProcessorSettings(payload);
  }

  async function getCandidateAiProcessorSettingsByVacancy(vacancyId) {
    const { response } = await Company.api().getCandidateAiProcessorSettingsByVacancy(vacancyId);
    return response.data;
  }

  async function updateCandidateAiProcessorSettingsByVacancy(vacancyId, payload) {
    await Company.api().updateCandidateAiProcessorSettingsByVacancy(vacancyId, payload);
  }

  return {
    updateSettings,
    addresses,
    company,
    fetch,
    getIntegrationTokenStatus,
    getTemplates,
    templates,
    updateTemplateSettings,
    applyTemplate,
    setRedacting,
    disableAllTemplates,
    addCandidatesAdditionalFields,
    getCandidateAiProcessorSettings,
    updateCandidateAiProcessorSettings,
    getCandidateAiProcessorSettingsByVacancy,
    updateCandidateAiProcessorSettingsByVacancy,
  };
}
